import React from "react";
import directoryOpenFileMyDocs from "../../../../assets/images/directory.png";
import minesweeperIcon from "../../../../assets/images/minesweeper.png";
import tetrisIcon from "../../../../assets/images/tetrisIcon.png";
import Minesweeper from "../Games/Minesweeper/MineSweeper";
import Tetris from "../Games/Tetris/Tetris";
import Snake from "../Games/Snake/Snake";
import { useWindowManager } from "../../utils/WindowManager";
import {
  calculateCenterPosition,
  getRandomWindowPosition,
} from "../../utils/utils";

export interface DesktopApp {
  iconSrc: string;
  name: string;
  description?: string;
  isGame?: boolean;
  showAddressBar?: boolean;
  addressBarLink?: string;
  showBottomBar?: boolean;
  component: React.ComponentType | React.ReactNode;
}

// Kept separate from desktopApps so windows like My Computer can list games
// without importing the full desktop app list (which imports them back).
export const GAME_APPS: DesktopApp[] = [
  {
    iconSrc: minesweeperIcon,
    name: "Minesweeper",
    description: "The classic. Left-click to reveal, right-click to flag.",
    component: Minesweeper,
    isGame: true,
  },
  {
    iconSrc: tetrisIcon,
    name: "Tetris",
    description:
      "Arrow keys to move and rotate, space to hard drop, P to pause.",
    component: Tetris,
    isGame: true,
  },
  {
    iconSrc: directoryOpenFileMyDocs,
    name: "Snake",
    description: "Eat, grow, don't bite yourself. Arrow keys to steer.",
    component: Snake,
    isGame: true,
  },
];

export const useOpenApp = () => {
  const { openWindow } = useWindowManager();

  return (app: DesktopApp) => {
    openWindow({
      windowTitle: app.name,
      component: app.component,
      position: getRandomWindowPosition(calculateCenterPosition(400, 300)),
      size: {
        width: 0,
        height: 0,
      },
      isMinimized: false,
      isMaximized: false,
      icon: app.iconSrc,
      showAddressBar: app.showAddressBar,
      addressBarLink: app.addressBarLink,
      showBottomBar: app.showBottomBar,
    });
  };
};
